package one.devsbox.shared.ads

import one.devsbox.commons.EType

enum class TargetType(override val mask: Int, val dbSuffix: List<Int>) : EType {
    USER(2, listOf(1)),
    RESOURCE(4, listOf(50, 51, 52)),
    DEVICE(8, listOf(2)),
    LOCATION(16, listOf(2)),
    CAMPAIGN(32, listOf(5)),
    COMPANY(64, listOf(6)),
    APPLICATION(128, listOf(7)), ;

    companion object : EType.Finder<TargetType>(entries)
}